import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthService} from '../../../services/auth/auth.service';
import {PlatformService} from '../../../services/platform/platform.service';
import {Router, RouterLink} from '@angular/router';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {UserService} from '../../../services/user/user.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MetaService} from '../../../services/meta/meta.service';
import {PageService} from '../../../services/page/page.service';
import {ResellerService} from '../../../services/reseller/reseller.service';
import { RedirectService } from 'src/app/services/redirect/redirect.service';
import {CommonModule} from '@angular/common';
import {ResellerImagePipe} from '../../../pipes/reseller-image.pipe';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {AlertService} from '../../../services/alert/alert.service';

@Component({
  selector: 'app-signin',
  standalone: true,
  imports: [
    CommonModule,
    ResellerImagePipe,
    TranslateModule,
    SpinnerComponent,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

  @Input() params: any;
  loading = false;
  showPassword = false;
  form: FormGroup;
  reseller = null;

  constructor(
    private platformSrv: PlatformService,
    private authSrv: AuthService,
    private userSrv: UserService,
    private router: Router,
    public langSrcSrv: LangSrcService,
    private metaSrv: MetaService,
    private translate: TranslateService,
    public pageSrv: PageService,
    private resellerSrv: ResellerService,
    private redirectSrv: RedirectService,
    private alertSrv: AlertService
  ) {
    this.form = new FormGroup({
      login: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    });
  }

  async ngOnInit() {
    const { hostname }  = new URL(location.href);
    const [subdomain] = hostname.split('.');
    if (subdomain !== 'app') {
      this.reseller = await this.resellerSrv.getImage(subdomain);
    }
    this.translate.get(`Connexion`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
  }

  signInProvider(provider: string) {

  }

  async onSubmit() {
    this.loading = true;
    this.authSrv.login(this.form.value).subscribe(
      data => this.success(data),
      (error) => {
        this.loading = false;
        const message = error?.error?.message || 'Identifiants incorrects.';
        this.alertSrv.error(message);
      }
    );
  }

  async success(data: any) {

    // 1. store token
    this.authSrv.storeToken(data.token);

    // 2. store user
    await this.authSrv.storeUser();

    // redirect to custom route
    if (this.params && this.params.redirectAfterLogin) {
      await this.router.navigateByUrl(this.params.redirectAfterLogin);
      return;
    }

    // redirect to dashboard
    // Check if User has reseller with subdomain
    // On a alias domain (e.g. seriousgame.wefitgroup.com) we never switch subdomain
    const user = await this.authSrv.getUser();
    if  (!this.redirectSrv.isAliasHost() && user.reseller && user.reseller.url && user.reseller.url !== location.hostname.split('.')[0]) {
    // If User has reseller, reseller has subdomain and actual subdomain & reseller subdomain doesnt match then redirect user to correct subdomain

      await window.open(`${location.protocol}//${this.redirectSrv.buildHost(user.reseller.url)}/${this.langSrcSrv.current.shortCode}/auth/auto/${data.token}`, '_self');
      return;
    }
    if (!this.redirectSrv.isAliasHost() && !user.reseller && this.reseller) {
      await window.open(`${location.protocol}//${this.redirectSrv.buildHost('app')}/${this.langSrcSrv.current.shortCode}/auth/auto/${data.token}`, '_self');
      return;
    }
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'learning', 'dashboard']);
   }

  goToOf() {
    if (this.reseller.link) {
      window.open(this.reseller.link, '_blank');
    }
  }
}
